import { type SyntheticEvent, type MouseEvent } from 'react'

export const isUserInputEvent = <T>(event: SyntheticEvent<T>): event is MouseEvent<T> => {
  const native = event.nativeEvent
  return native instanceof MouseEvent || native instanceof KeyboardEvent
}
